import React, { useEffect, useState, useRef } from "react";
import tmdbApi from "../api/tmdbApi";
import { useParams } from "react-router-dom";
import Footer from "../components/footer/Footer";
// import SideMenu from "../student/SideMenu";
// import Sidebar from "../components/dashboard/sidebar";
import Header from "../components/dashboard/header";
import { useNavigate, Link } from "react-router-dom";

import total from "../assets/images/icons/total-score.svg"
import percentage from "../assets/images/icons/percentage.svg"
import OpenSeadragon from "openseadragon";
import deepZoom from "../assets/images/icons/Dna-dz.svg";
import SideMenu from "./student/SideMenu";



const CPCResult = () => {

    let { id } = useParams();
    const navigate = useNavigate()
    const [ans, setAns] = useState([])
    const [cases, setCases] = useState([]);
    const [popupImage, setPopupImage] = useState(null);
    const [popupPngImage, setPopupPngImage] = useState(null);

    useEffect(() => {
        getCpcQuizInfo()
    }, []);

    const imageData = (caseid, files) => {
        let data = cases?.questionData?.find((item) => item.caseid === caseid) || null
        return data ? data[files] : []
    }

    const handlePngPopupImage = (imageUrl) => {
        setShowImagePopup(true)
        setPopupImage(imageUrl)
        setPopupPngImage(imageUrl)
    }

    const getExtension = (filename) => {
        // debugger
        if (!filename) return null;
        let extType = filename.split('.').pop().toLowerCase();
        let valReturn = ".jpeg,.jpg,.png";
        if (extType === 'tiff' || extType === 'tif') {
            valReturn = ".tif,.tiff";
        }
        return valReturn
    };

    const handlePopupload = (e) => {
        setPopupLoading(true)
    }

    const handleBack = () => {
        navigate(-1)
    }
    const customComponents = {
        DropdownIndicator: () => null, // Remove the dropdown indicator
        IndicatorSeparator: () => null, // Optionally remove the separator
    };
    const viewerRef = useRef(null);
    const [showImagePopup, setShowImagePopup] = useState(false);
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
    const [dziUrl, setDziUrl] = useState("");
    const [dziUrlFile, setDziUrlFile] = useState("");

    const [dzipopupImage, setDZIPopupImage] = useState(false);
    const [isPopupLoading, setPopupLoading] = useState(false);
    const [viewer, setViewer] = useState(null);
    const [resetpopup, setresetpopup] = useState(false);
    const [rotation, setRotation] = useState(0);

    const [image, setImg] = useState('');
    const [imageCloudfront, setimageCloudfront] = useState('');
    const [resourceImg, setResourceImg] = useState('');


    const getCpcQuizInfo = async () => {
        try {
            const response = await tmdbApi.cpcParticipantAnswersInfo(id);

            const result = response?.result;
            if (!result || typeof result === "string") {
                console.warn("Invalid CPC response:", result);
                return;
            }

            // Store answers
            setAns(result);

            // Extract caseIds safely
            const caseIds =
                result?.participantAnswers?.[0]?.cases
                    ?.map(item => item.caseid)
                    ?.filter(Boolean) || [];

            const moduleId = result?.cpcDetails?.moduleid;

            // Guard conditions before next API call
            if (!caseIds.length) {
                console.warn("No caseIds found, skipping cpcCaseModuleInfo");
                return;
            }

            if (!moduleId) {
                console.warn("No moduleId found, skipping cpcCaseModuleInfo");
                return;
            }

            // Call dependent API only when data is ready
            const res = await tmdbApi.cpcCaseModuleInfo(caseIds, moduleId);

            if (res?.result) {
                setCases(res.result);
            }
        } catch (error) {
            console.error("Error while fetching CPC quiz info:", error);
        }
    };


    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                    setimageCloudfront(window.site.common.imageCloudfront)
                    setResourceImg(window.site.common.resourceBucket)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            console.log('window.site.common', window.site.common)
            setImg(window.site.common.imageCloudfront)
            setimageCloudfront(window.site.common.imageCloudfront)
            setResourceImg(window.site.common.resourceBucket)
        }


    }, [window.site]);
    useEffect(() => {
        if (!viewerRef.current) return;

        console.log("Loading OpenSeadragon with URL:", dziUrl);
        const isDziURL = dziUrl.includes("output.dzi");
        const { width, height } = imageDimensions; // Destructure imageDimensions for clarity

        const tileSource = isDziURL
            ? {
                Image: {
                    xmlns: "http://schemas.microsoft.com/deepzoom/2008",
                    Url: encodeURI(dziUrl),
                    Format: "jpeg",
                    Overlap: 2,
                    TileSize: 256,
                    Size: { Width: width, Height: height },
                },
            }
            : {
                type: "image",
                url: encodeURI(dziUrl),
                buildPyramid: false,
            };

        const osdViewer = OpenSeadragon({
            id: "openseadragon-viewer",
            prefixUrl: "https://openseadragon.github.io/openseadragon/images/",
            tileSources: tileSource,
            showNavigator: true,
            crossOriginPolicy: "Anonymous",
            navigatorPosition: "BOTTOM_RIGHT",
            maxZoomPixelRatio: 10,
            minZoomImageRatio: 0.5,
            visibilityRatio: 1,
            zoomPerScroll: 2,
            homeFillsViewer: true,
            gestureSettingsMouse: {
                clickToZoom: true,
                dblClickToZoom: true,
                flickEnabled: true,
                pinchToZoom: true,
                scrollToZoom: true,
            },
            showZoomControl: true,
            showHomeControl: true,
            showFullPageControl: true,
            showRotationControl: true,
            wrapHorizontal: false,
        });


        setViewer(osdViewer);

        return () => {
            if (osdViewer) {
                osdViewer.destroy();
            }
        };
    }, [dziUrl, imageDimensions]);
    const closeDeepZoom = () => {
        setPopupOpen(false);
        setDziUrl("");
        setDziUrlFile("");
        setImageDimensions({ width: 0, height: 0 });
        if (viewer) {
            viewer.destroy();
            setViewer(null);
        }
    };
    const getYouTubeVideoId = (url) => {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const match = url?.match(regExp);
        return match && match[7].length === 11 ? match[7] : null;
    };
    const [showVideoPopup, setShowVideoPopup] = useState(false);
    const handleVideoPopupClose = () => {
        setShowVideoPopup(false);
    };
    return (
        <div id="layout-wrapper" className="create-case">
            <Header />
            <SideMenu />
            <div className="main-content user-management cpc-results-table" id="main-content">
                <div className="page-content" id="page-content">
                    <div className="container-fluid" id="container-fluid">
                        <div className="row  breadcrumb" id="breadcrumb-row">
                            <div className="col-lg-12 cpc-results-line p-0">
                                <div className="d-flex align-items-center justify-content-between flex-wrap col-lg-12">
                                    <div className="col-lg-8">
                                        <h4 className="card-title" id="breadcrumb-title">
                                            CPC Results
                                        </h4>


                                    </div>
                                    <div className="answer-block answer-flex col-lg-4">
                                        <div className="answer-row">
                                            <span className="correct-answer answer-dot"></span>
                                            <p>Admin Answer</p>
                                        </div>
                                        <div className="answer-row">
                                            <span className="actual-answer answer-dot"></span>
                                            <p>Your Correct Answer</p>
                                        </div>
                                        <a onClick={handleBack} className="create-quiz-btn">back</a>
                                    </div>


                                </div>
                            </div>
                        </div>


                        <div className="row table-data">



                            <div className="col-12 d-flex justify-content-between flex-wrap case-main-heading">

                                <div className="col-lg-8 col-md-8 col-12">
                                    <h2 className="quiz-title">{ans && ans?.cpcDetails?.title}</h2>
                                    {/* <p className="quiz-para">{ans && ans?.cpcDetails?.description}</p> */}
                                    <p className="quiz-para">  {ans?.cpcDetails?.description?.replace(/<\/?[^>]+(>|$)/g, "")}</p>
                                    <p className="marks-sidehe"><img src={total} alt="" /> Total Score : <span className="marks-txt">{ans && ans?.participantAnswers && ans?.participantAnswers[0] && ans?.participantAnswers[0]?.cpcResult}</span></p>
                                    <p className="marks-sidehe"><img src={percentage} alt="" /> Percentile : <span className="marks-txt">{ans && ans?.participantAnswers && ans?.participantAnswers[0] && ans?.participantAnswers[0]?.percentileRank}</span></p>
                                </div>
                                {ans?.cpcDetails?.videoLink && <div className="col-lg-3 col-md-3 col-12">
                                    <h2 className="quiz-title">Video</h2>
                                    <div className="video-card">
                                        <img src={ans?.cpcDetails?.videoLink ? `https://img.youtube.com/vi/${getYouTubeVideoId(ans?.cpcDetails?.videoLink)}/0.jpg` : `https://img.youtube.com/vi/0.jpg`} alt="Thumbnail" />
                                        <button className="play-btn" >
                                            <span className="material-symbols-outlined" style={{ cursor: "pointer" }}
                                                onClick={() => setShowVideoPopup(true)}>
                                                play_arrow
                                            </span>
                                        </button>
                                    </div>
                                </div>}
                                {ans?.cpcDetails?.videoLink &&
                                    <div className="cpcquiz-line1"></div>}
                            </div>
                            {showVideoPopup && (
                                <div
                                    style={{
                                        position: "fixed",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        backgroundColor: "rgba(0,0,0,0.8)",
                                        zIndex: 1000,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                    onClick={() => setShowVideoPopup(false)}
                                >
                                    <div style={{ position: "relative", width: "80%", maxWidth: "800px" }}>
                                        <iframe
                                            width="100%"
                                            height="450"
                                            src={`https://www.youtube.com/embed/${getYouTubeVideoId(
                                                ans?.cpcDetails?.videoLink
                                            )}`}
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                            title="Video Preview"
                                        ></iframe>
                                        <button className="video-btn-close"
                                            onClick={() => setShowVideoPopup(false)}
                                            style={{
                                                position: "absolute",
                                                color: "white",
                                                border: "none",
                                                cursor: "pointer",
                                            }}
                                        ><span className="material-symbols-outlined">close</span>

                                        </button>
                                    </div>
                                </div>
                            )}
                            {ans && ans?.participantAnswers && ans?.participantAnswers[0]?.cases?.map((item, qIndex) => {
                                // const caseData = cases.find(c => c.caseid === item.caseid);
                                // const caseDesc = caseData?.clinicalhistory || "";
                                // const answers = item.answers || [];
                                return (
                                    <div className="col-12  case-main-cases mt-3 case-exp-img" key={qIndex}>
                                        <div className="d-flex flex-wrap justify-content-between">
                                            <div className="col-lg-8 col-md-8 col-12 case-exp-img-line">
                                                <h2 className="quiz-title">
                                                    {/* {item?.diagnosis} */}

                                                    {"Case " + (qIndex + 1)}
                                                </h2>
                                                <p className="quiz-para" dangerouslySetInnerHTML={{ __html: item?.clinicalhistory }}></p>

                                                {item?.explanation && (
                                                    <p>
                                                        <b>Explanation:</b> {item.explanation.replace(/<[^>]*>/g, '')}
                                                    </p>
                                                )}

                                                <p>{item?.answer1?.label ? <span><b>Diagnostics: </b>{item?.answer1?.label}</span> : ''}
                                                    {item?.answer2?.label ? `, ${item?.answer2?.label}` : ''}
                                                    {item?.answer11?.label ? `, ${item?.answer11?.label}` : ''}</p>

                                            </div>
                                            <div className="col-lg-3 col-md-3 col-12 cpc-results-img">
                                                <div className="d-flex gap-1 flex-wrap case-block question_block">


                                                    {cases?.questionData?.length > 0 && <div className={imageData(item?.caseid, 'files')?.length > 0 ? "quiz_info content" : "quiz_info no-image content"}>
                                                        <div className="d-grid justify-content-start gap-2 align-items-center">
                                                            <div>
                                                                {imageData(item?.caseid, 'files')?.length > 0 && <p className="mt-2 quiz-title">Histological Photos</p>}
                                                                <div className="mod-lib-clinic-history-img">
                                                                    {imageData(item?.caseid, 'files').map((file, fileIndex) => (
                                                                        file.uploadStatus == "COMPLETED" &&
                                                                        <div
                                                                            key={fileIndex}
                                                                            className="img"
                                                                            style={{ width: 'auto' }}
                                                                            onClick={(e) => {
                                                                                let filepath = file?.sourcepath || file?.filepath || "";
                                                                                let imagePath = `${imageCloudfront}${filepath && filepath?.replace(/ /g, "%20")}?auto=compress,format`


                                                                                //handlePopupImage(imagePath)
                                                                                setPopupOpen(true);
                                                                                setImageDimensions({ width: file.width, height: file.height });

                                                                                let path = file.dziUrl || "";
                                                                                if (path.startsWith("/")) path = path.slice(1);
                                                                                let isDziURL = path.includes("output.dzi");
                                                                                if (isDziURL) {
                                                                                    path = `${path}_files/`;
                                                                                    setDziUrl(imageCloudfront + path);
                                                                                } else {
                                                                                    setDziUrl(imagePath);
                                                                                }

                                                                                setDziUrlFile(file?.originalFilename ? file?.originalFilename : file.filename)
                                                                                setDZIPopupImage(imageCloudfront + file.sourcepath);
                                                                                handlePopupload(e);

                                                                            }}
                                                                        >
                                                                            <span className="material-symbols-outlined img_view"
                                                                                style={{ backgroundColor: 'transparent' }}
                                                                            >zoom_out_map</span>

                                                                            <span className="default-img">


                                                                                <img src={file?.thumbnailUrl ? imageCloudfront?.replace(/\/$/, "") + file?.thumbnailUrl + "?auto=compress,format&width=150" : (

                                                                                    file?.sourcepath ? `${imageCloudfront}${file?.sourcepath && file?.sourcepath?.replace(/ /g, "%20")}?auto=compress,format` : deepZoom
                                                                                )} alt={file?.originalFilename} />

                                                                            </span>


                                                                        </div>


                                                                    ))}

                                                                </div>
                                                            </div>
                                                            <div className="mt-1">

                                                                {imageData(item?.caseid, 'historyfiles')?.length > 0 &&
                                                                    <p className="quiz-title col-lg-12">Clinical History Photos</p>}
                                                                <div className="mod-lib-clinic-history-img">

                                                                    {imageData(item?.caseid, 'historyfiles')?.length > 0 && imageData(item?.caseid, 'historyfiles')?.map((file, key) => {

                                                                        let filepath = file?.sourcepath || file?.filepath || "";
                                                                        let imagePath = `${imageCloudfront}${filepath && filepath?.replace(/ /g, "%20")}?auto=compress,format`

                                                                        return (

                                                                            <div
                                                                                key={key}
                                                                                className="img"
                                                                                style={{ width: 'auto' }}
                                                                                onClick={(e) => handlePngPopupImage(imagePath)}
                                                                            >
                                                                                <span className="material-symbols-outlined img_view img-zoom"
                                                                                    style={{ backgroundColor: 'transparent' }}>zoom_out_map</span>
                                                                                <img
                                                                                    src={`${imageCloudfront}${filepath?.replace(/ /g, "%20")}?auto=compress,format&width=125`}
                                                                                    alt={`Image ${key + 1}`}
                                                                                    loading="lazy"
                                                                                />
                                                                            </div>


                                                                        )
                                                                    })}


                                                                </div>
                                                            </div>


                                                        </div>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                            <div className="cpcquiz-line2"></div>

                                        </div>
                                        <div className="col-lg-8">
                                            {/* <h2 className="quiz-title">{ans && ans?.cpcDetails?.title}</h2>
                                        <div className="col-lg-8">
                                            {/* <h2 className="quiz-title">{ans && ans?.cpcDetails?.title}</h2>
                                    <p className="quiz-para">{ans && ans?.cpcDetails?.description}</p> */}
                                            <p className="marks-sidehe"><img src={total} alt="" /> Total Score : <span className="marks-txt">{item?.caseResult}</span></p>
                                            {/* <p className="marks-sidehe"><img src={percentage} alt="" /> Percentile : <span className="marks-txt">{ans && ans?.participantAnswers && ans?.participantAnswers[0] && ans?.participantAnswers[0]?.percentileRank}</span></p> */}
                                        </div>
                                        <div className="mt-4">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr className="case-question" style={{ backgroundColor: '#ffffff' }}>
                                                        <th>Answer</th>
                                                        <th className="text-center">Points</th>
                                                        <th className="text-center">Weightage</th>
                                                        <th className="text-center">Score</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {item?.answers?.map((ansItem, aIndex) => {
                                                        const hasKey = ansItem?.hasOwnProperty('isCorrect');

                                                        // let rowStyle = hasKey ? {} : { backgroundColor: '#90EE90' };
                                                        // const rowStyle = hasKey
                                                        //     ? ansItem?.isCorrect && ansItem?.weightage > 0
                                                        //         ? { backgroundColor: '#b4dfdb' }
                                                        //         : { backgroundColor: 'none' }
                                                        //         : { backgroundColor: '#FFE8DB' };

                                                        const rowStyle = ansItem?.isCorrect && ansItem?.weightage > 0
                                                            ? { backgroundColor: '#b4dfdb' }        // correct + has weightage
                                                            : !ansItem?.isCorrect && ansItem?.weightage > 0
                                                                ? { backgroundColor: 'none' }  // wrong + has weightage
                                                                : { backgroundColor: '#FFE8DB' };     // else case


                                                        return (
                                                            !((ansItem?.points === 0 || ansItem?.points === null) && !ansItem?.weightage) && (
                                                                <tr key={aIndex} className="case-question" style={rowStyle}>
                                                                    <td>{ansItem?.answer}</td>
                                                                    {/* <td className="text-center">{ansItem?.points || 0}</td> */}
                                                                    <td className="text-center">{ansItem?.points !== null ? ansItem.points : 0}</td>
                                                                    <td className="text-center">{!hasKey ? '0' : ansItem?.weightage}</td>
                                                                    <td className="text-center">{ansItem?.score || 0}</td>
                                                                </tr>
                                                            )
                                                        )
                                                    })}
                                                </tbody>

                                            </table>


                                        </div>
                                        {/* <div className="cpcquiz-line1"></div> */}
                                    </div>
                                );
                            }
                            )}


                        </div>
                    </div>
                    <Footer />
                </div>




            </div>
            {/* Deep Zoom Popup */}
            {isPopupOpen && dziUrl && (
                <div className="deep_zoom">
                    <div
                        style={{
                            position: "fixed",
                            top: '0',
                            left: '0',
                            right: '0',
                            bottom: '0',
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 999,
                            borderRadius: "18px"
                        }}
                    >
                        <div style={{
                            width: "98vw",
                            height: "98vh",
                            position: "relative",
                            backgroundColor: "black",
                            overflow: "hidden"
                        }}>
                            {/* Deep Zoom Header */}
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "10px 20px",
                                backgroundColor: "#f8f9fa",
                                borderBottom: "1px solid #dee2e6"
                            }}>
                                <h3 style={{ fontSize: "18px" }}>
                                    {/* {dziUrlFile ? dziUrlFile : ""} */}
                                </h3>
                                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                    {/* <button
                                    className="create-quiz-btn border-0"
                                    onClick={resetZoom}
                                >
                                    Reset View
                                </button> */}
                                    {/* <button
                                    onClick={() => rotateImage(90)}
                                    className="create-quiz-btn border-0"

                                >
                                    Rotate 90°
                                </button> */}
                                    <button
                                        className="dz_close"
                                        onClick={closeDeepZoom}
                                        style={{
                                            border: "none",
                                            borderRadius: "6px",
                                            fontWeight: "800",
                                        }}
                                    >
                                        <span className="material-symbols-outlined">close</span>
                                    </button>
                                </div>
                            </div>

                            {/* Deep Zoom Viewer Container */}
                            <div style={{
                                height: "calc(95vh - 80px)",
                                width: "100%",
                                position: "relative"
                            }}>
                                <div
                                    id="openseadragon-viewer"
                                    ref={viewerRef}
                                    style={{
                                        height: "100%",
                                        width: "100%"
                                    }}
                                />

                                {/* Instructions */}
                                {/* <div style={{
                                position: "absolute",
                                bottom: "20px",
                                left: "20px",
                                backgroundColor: "rgba(0, 0, 0, 0.7)",
                                color: "white",
                                padding: "10px",
                                borderRadius: "5px",
                                fontSize: "12px"
                            }}>
                                <p style={{ margin: "2px 0" }}>• Zoom with mouse wheel or pinch gesture</p>
                                <p style={{ margin: "2px 0" }}>• Pan by clicking and dragging</p>
                                <p style={{ margin: "2px 0" }}>• Use the navigator in the bottom-right for orientation</p>
                                <p style={{ margin: "2px 0" }}>• Use toolbar buttons to rotate or reset view</p>
                            </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {showImagePopup && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0,0,0,0.8)",
                        zIndex: 1003,
                        display: "flex",
                        alignItems: "start",
                        justifyContent: "center",
                        padding: "20px", // padding all around
                    }}
                    onClick={() => setShowImagePopup(false)}
                >
                    <div
                        style={{
                            position: "relative",
                            width: "auto",
                            height: "100%",
                            padding: "20px", // inner padding so image doesn't touch edges
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "start",
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <img
                            src={popupImage}
                            style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "contain",
                                display: "block",
                            }}
                        />

                        <button
                            className="dz_close"
                            onClick={() => setShowImagePopup(false)}
                            style={{
                                position: "absolute",
                                top: 30,
                                right: 30,
                                cursor: "pointer",
                                borderRadius: "6px",
                            }}
                        >
                            <span className="material-symbols-outlined">close</span>
                        </button>
                    </div>
                </div>


            )}


            {dziUrl && (
                <section className="viewer-section">
                    <div className="viewer-header">
                        <h2>Deep Zoom Viewer</h2>
                        <div className="viewer-controls">
                            <button className="control-button" onClick={() => window.location.reload()}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 2v6h-6"></path>
                                    <path d="M3 12a9 9 0 0 1 15-6.7L21 8"></path>
                                    <path d="M3 22v-6h6"></path>
                                    <path d="M21 12a9 9 0 0 1-15 6.7L3 16"></path>
                                </svg>
                                <span>Reset</span>
                            </button>
                        </div>
                    </div>

                    <div className="viewer-container">
                        <div id="openseadragon-viewer" ref={viewerRef}></div>
                        <div className="viewer-instructions">
                            <p>• Zoom with mouse wheel or pinch gesture</p>
                            <p>• Pan by clicking and dragging</p>
                            <p>• Use the navigator in the bottom-right for orientation</p>
                        </div>
                    </div>
                </section>
            )}
        </div>



    )

}
export default CPCResult;
